export default __webpack_public_path__ + "static/media/rightbg.406a29d1.svg";